import * as i18n from './i18n';
import setNoticeError from './setNoticeError';
import setNoticeSuccess from './setNoticeSuccess';
import resetNotice from './resetNotice';

const operations = {
  ...i18n,
  setNoticeError,
  setNoticeSuccess,
  resetNotice,
};

export default operations;
